// Past events
jQuery('.past').bind("click", function() {
  jQuery(this).siblings().removeClass('active');
  jQuery(this).addClass('active');
  ShowEvents('past');
});

// Future events
jQuery('.future').bind("click", function() {
  jQuery(this).siblings().removeClass('active');
  jQuery(this).addClass('active');
  ShowEvents('future');
});

// Set future events as default
jQuery(document).ready(function() {
  jQuery('.future').addClass('active');
   ShowEvents('future');
 });

function ShowEvents(time) {
  jQuery('.tablepress tr').children('td:first-child').each(function () {
    var date = this.innerHTML;
    var date = new Date(date);
    var today = new Date();
    today.setHours(0,0,0,0);
    jQuery(this).parent().show();
    if(time == 'future' && date <= today) {
      jQuery(this).parent().hide();
      //console.log(date + " | " + today);
    }
    else if(time == 'past' && date > today) {
      jQuery(this).parent().hide();
      //console.log(date + " | " + today);
    }
  });
} 
